import uk from 'antd/es/date-picker/locale/uk_UA';
import en from 'antd/es/date-picker/locale/en_US';

export const getFormat = type => {
    switch (type) {
        case 'week':
            return date => `${date.year()}-${date.week()}th`;
        case 'month':
            return 'MMM';
        case 'quarter':
            return '[Q]Q';
        case 'year':
            return 'YYYY';
        default:
            return 'DD.MM.YYYY';
    }
};

export const getLocale = language => {
    switch (language) {
        case 'uk':
            return uk;
        default:
            return en;
    }
};
